var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Work Views","items":_vm.views,"item-text":"name","return-object":"","clearable":""},on:{"change":_vm.setWorkView},model:{value:(_vm.selectedView),callback:function ($$v) {_vm.selectedView=$$v},expression:"selectedView"}})
}
var staticRenderFns = []

export { render, staticRenderFns }